import hotkeys from 'hotkeys-js'

const registeredHotkeys = {}

hotkeys.filter = function (event) {
  if (event.target.closest('.no-hotkeys')) {
    return false
  }
  return true
}
const CONFLICT_MODES = {
  WARN: 'warn',      // Log warning but allow overwrite
  ERROR: 'error',    // Throw error and prevent overwrite
  SILENT: 'silent'   // Silently overwrite
}

export default {
  install(app) {
    app.config.globalProperties.$bindHotkeys = (keyCombo, handler, description = '', conflictMode = CONFLICT_MODES.WARN) => {
      // Check for conflicts
      if (registeredHotkeys[keyCombo] && conflictMode !== CONFLICT_MODES.SILENT) {
        const message = `Hotkey conflict: "${keyCombo}" is already registered with description "${registeredHotkeys[keyCombo].description}"`
        
        if (conflictMode === CONFLICT_MODES.ERROR) {
          throw new Error(message)
        } else if (conflictMode === CONFLICT_MODES.WARN) {
          console.warn(message)
        }
      }
      
      // Register the hotkey
      hotkeys(keyCombo, (event, hotkeyHandler) => {
        event.preventDefault()
        handler(event, hotkeyHandler)
      })

      registeredHotkeys[keyCombo] = {
        description,
        handler
      }

      return () => {
        hotkeys.unbind(keyCombo)
        delete registeredHotkeys[keyCombo]
      }
    }

    app.config.globalProperties.$getRegisteredHotkeys = () => {
      return { ...registeredHotkeys }
    }

    app.config.globalProperties.$unbindHotkey = (keyCombo) => {
      if (registeredHotkeys[keyCombo]) {
        hotkeys.unbind(keyCombo)
        delete registeredHotkeys[keyCombo]
        return true
      }
      return false
    }

    app.config.globalProperties.$unbindAllHotkeys = () => {
      Object.keys(registeredHotkeys).forEach(keyCombo => {
        hotkeys.unbind(keyCombo)
      })
      Object.keys(registeredHotkeys).forEach(key => delete registeredHotkeys[key])
    }
    app.config.globalProperties.$HOTKEY_CONFLICT_MODES = CONFLICT_MODES
  }
}
